<template>
  <div
    v-if="$auth.loggedIn && !loading"
    :class="{ transparent: !$vuetify.theme.dark }"
    class="mt-4"
  >
    <v-card outlined>
      <v-container>
        <v-row>
          <v-col class="py-0 px-0" :class="{ white: !$vuetify.theme.dark }">
            <v-sheet
              tile
              class="primary px-3 py-2 text-uppercase white--text caption"
              style="text-align: center"
            >
              Favourites
            </v-sheet>
            <v-card v-if="!favorites.length" dense>
              <v-card-text class="text-center">
                <v-btn icon color="amber" class="align-self-center" height="35">
                  <v-icon>mdi-star-outline</v-icon>
                </v-btn>
                <v-icon size="30" color="amber">mdi-star-online</v-icon>
                <div class="py-2">Add to favorite</div>
              </v-card-text>
            </v-card>
            <v-skeleton-loader
              v-if="loading"
              tile
              light
              dense
              type="list-item-two-line"
            >
            </v-skeleton-loader>
            <div v-for="(favorite, i) in favorites" :key="i">
              <v-tab
                class="body-2 primary--text text-uppercase font-weight-bold caption pa-2 d-flex"
              >
                <v-img
                  class="mb-1"
                  width="22"
                  max-height="22"
                  style="margin: 0 -10px 0 -20px"
                  contain
                  rounded
                  alt="favoriteicon"
                  :src="
                    getIcon(
                      favorite.tab === '2'
                        ? 'Tennis'
                        : favorite.tab === '1'
                        ? 'Soccer'
                        : favorite.tab === '4'
                        ? 'Cricket'
                        : 'Election'
                    )
                  "
                ></v-img>
                <span class="text-left flex-grow-1">
                  {{
                    favorite.tab === '2'
                      ? 'Tennis'
                      : favorite.tab === '1'
                      ? 'Soccer'
                      : favorite.tab === '4'
                      ? 'Cricket'
                      : 'Election'
                  }}
                </span>
              </v-tab>
              <v-divider :key="'divider'"></v-divider>
              <!-- betiing cards -->

              <v-list class="mt-0 pt-0">
                <template v-for="(fixture, j) in favorite.fixtures">
                  <v-list-item
                    :key="j"
                    class="px-1 white"
                    light
                    :to="
                      $route.params &&
                      $route.params.category &&
                      fixture &&
                      fixture.competition &&
                      fixture.competition.id &&
                      fixture.event &&
                      fixture.event.id &&
                      `/sportsbook/${fixture.eventTypeId}/${fixture.competition.id}/${fixture.event.id}`
                    "
                  >
                    <v-list-item-content class="text-center">
                      <v-list-item-title>
                        <v-list-item-subtitle
                          class="overtext-removed"
                          style="font-size: 12px"
                        >
                          {{ fixture.event.name }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="pb-2">
                          <span
                            v-if="getTitle(fixture.marketStartTime)"
                            style="font-size: 10px"
                          >
                            {{ getTitle(fixture.marketStartTime) }}
                          </span>
                        </v-list-item-subtitle>
                      </v-list-item-title>
                      <v-divider :key="'divider' + fixture.id"></v-divider>
                      <item-odds
                        :show-heading="false"
                        class="center"
                        :runners="
                          fixture.runners.length <= 0
                            ? [{ name: fixture.name }]
                            : fixture.runners
                        "
                        :market-id="fixture.id"
                        :event="fixture"
                        :market="fixture"
                        :two-odds="true"
                        :bookmaker="fixture.name !== 'Match Odds'"
                        favorite-odds
                      ></item-odds>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider :key="'divider' + fixture.id"></v-divider>
                </template>
              </v-list>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import ItemOdds from '@/components/ItemOdds'
export default {
  components: {
    ItemOdds
  },
  middleware: 'validateUser',
  data() {
    return {
      refresh: true,
      twoOdds: true,
      tabs: 0,
      interval: ''
    }
  },
  computed: {
    ...mapState({
      favorites: (state) => state.favorites.data,
      loading: (state) => state.favorites.loading,
      isEmpty: (state) => state.favorites.isEmpty,
      matchIds: (state) => state.favorites.matchIds,
      selectedBetfairId: (state) => state.placeBet.runner,
      loadingFav: (state) => state.favorites.loadingFav
    })
  },
  watch: {
    async loadingFav() {
      if (!this.loadingFav && this.$auth.loggedIn) {
        await this.$store.dispatch('favorites/get')
      }
    }
  },
  async created() {
    try {
      if (this.$auth.loggedIn) {
        this.$store.commit('favorites/set_loadingFav', false)
      }

      if (this.$auth.loggedIn && this.matchIds.length > 0) {
        await this.$store.dispatch(
          'betBooks/getAll',
          this.matchIds,
          this.refresh
        )
      }
    } catch (error) {}
  },
  beforeDestroy() {
    this.$store.commit('favorites/set_loadingFav', true)
  },
  methods: {
    openAll(v) {
      return [...v.keys()].map((k, i) => i)
    },
    getIcon(text) {
      try {
        return require(`@/assets/images/sportsbook-categories/${text
          .replace(/([a-z])([A-Z])/g, '$1-$2') // get all lowercase letters that are near to uppercase ones
          .replace(/[\s_]+/g, '-') // replace all spaces and low dash
          .toLowerCase()}.png`)
      } catch (error) {
        return ''
      }
    },
    getTitle(startTime) {
      const fixturedate = this.$moment(startTime)
      if (this.$moment().isSame(this.$moment(fixturedate), 'week')) {
        return this.$moment(fixturedate).calendar()
      } else {
        return this.$moment(fixturedate).format('dddd, DD/MM hh:mm A')
      }
    }
  }
}
</script>
